// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules

import './modules/theme/menu/module';
import './modules/theme/hero-homepage/module';
import './modules/theme/services-cards/module';
import './modules/theme/about-us-3/module';

import './modules/evox/category-section-2/module';
// layouts

// leave me last
import './js/base/base-end';
